function arrayBufferWorkaround(this: any) {
    return new Promise((resolve) => {
        const filereader = new FileReader();

        filereader.onload = () => {
            resolve(filereader.result);
        };

        filereader.readAsArrayBuffer(this);
    });
}

// this workaround is for browsers (such as Safari) which have not implemented arrayBuffer
Blob.prototype.arrayBuffer = Blob.prototype.arrayBuffer || arrayBufferWorkaround;

const createSlice = (array: Uint8Array, start: number, end: number) => String.fromCharCode(...array.slice(start, end));

// buffer is chunked due to a safari issue with base64 images which are larger than 65k
const arrayBufferToBase64 = (buffer: any) => {
    const chunkSize = 8 * 1024;
    const arrayBuffer = new Uint8Array(buffer);
    const chunkCount = Math.ceil(arrayBuffer.length / chunkSize);
    let result = '';

    for (let i = 0; i <= chunkCount; i++) {
        result += createSlice(arrayBuffer, i * chunkSize, (i + 1) * chunkSize);
    }

    return result;
};

export const convertImageToBase64 = (promise: Promise<any>) =>
    promise
        .then((data) => data.arrayBuffer())
        .then(arrayBufferToBase64)
        .then(btoa);
